import styled from 'styled-components';

export const StyledRiskAlerts = styled.div`
  display: flex;
  flex-direction: row;
  color: var(--color-text-main);
  padding: 15px;
  box-shadow: 0px 0px 6px 0px #00000026;
  border-radius: 5px;
  background-color: #ffffff;

  .component-area {
    display: flex;
    flex-direction: column;
    flex: 1 1;
  }

  .component-title {
    font-size: 16px;
    font-weight: 600;
    color: #2f2f35;
    margin-bottom: 5px;
  }

  .component-body {
    padding: 0px 10px;
    gap: 7px;
    display: flex;
    flex-direction: column;
  }

  .btn-area {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .btn {
    height: 58px;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    gap: 20px;
  }

  .btn .btn-text {
    display: flex;
    flex-direction: column;
  }

  .btn .btn-text span {
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
  }

  .btn .btn-value {
    color: #ffffff;
    font-size: 20px;
    font-weight: 600;
  }

  .btn.warning {
    background-color: #ff8b29;
  }

  .btn.danger {
    background-color: #fc1e0f;
  }

  .time-line {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    width: 100%;
    min-width: 0;
    justify-content: center;
  }

  .time-line img {
    cursor: pointer;
  }

  .time-line-bar {
    flex: 1 1;
    width: 0;
    min-width: 0;
    overflow-x: auto;
    padding-top: 20px;
  }

  .time-line-track {
    display: flex;
    width: max-content;
    position: relative;
  }

  .time-line-bar .time-slot {
    width: 100px;
  }

  .time-slot-box {
    background-color: #fafafa;
    border: 1px solid #ebebeb;
    height: 50px;
    border-bottom: 4px solid #dadada !important;
    position: relative;
    display: flex;
    align-items: end;
  }

  .alert-marker {
    position: absolute;
    left: 50%;
    bottom: 20px;
    transform: translateX(-50%);
    width: 40px;
    height: 45px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }

  .alert-marker img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    max-width: none;
    max-height: none;
    flex-shrink: 0;
  }
`;
